import { Radio } from 'antd'
import { Form } from 'formsy-semantic-ui-react'
import * as R from 'ramda'
import React from 'react'
import { Modal, Label } from 'semantic-ui-react'
import { getImageUrl } from '../../utils'

export const SelectAddon = ({
  addons,
  handleChange,
  numberOf,
  handleRadioChange,
  type,
  race,
  selectedAddon,
  engrave,
  handleEngraveChange
}) => {
  const overrideTextChoices = {
    shirt: 'override_addon_main_text',
    v_shirt: 'override_addon_main_text',
    undershirt: 'override_addon_undershirt_text',
    buff: 'override_addon_buff_text',
    keychain: 'override_addon_keychain_text'
  }
  const overrideText = overrideTextChoices[type]
  const descriptionType = {
    shirt: 'เสื้อวิ่งคอกลม',
    v_shirt: 'เสื้อวิ่งคอวี',
    undershirt: race.id === 20 ? 'เสื้อคอวี' : 'เสื้อกล้าม',
    buff: 'ผ้าอเนกประสงค์',
    keychain: 'พวงกุญแจ'
  }
  const description =
    R.pathOr(null, [overrideText], race) ||
    descriptionType[type] ||
    addons[0].addon_type.display_title
  const priceChoices = {
    shirt: 300,
    v_shirt: 300,
    undershirt: 300,
    buff: 180,
    keychain: 0
  }
  const price = priceChoices[type] || addons[0].price
  const addonImageChoices = {
    shirt: 'addon_main_image',
    v_shirt: 'addon_main_image',
    undershirt: 'addon_undershirt_image',
    buff: 'addon_buff_image',
    keychain: 'addon_keychain_image'
  }
  const addonImage =
    R.path([addonImageChoices[type]], race) ||
    R.path(['addon_type', 'main_image'], addons[0]) ||
    R.path(['addon_main_image'], race)
  const sizeChartChoices = {
    shirt: 'size_chart',
    v_shirt: 'size_chart',
    undershirt: 'undershirt_size_chart',
    buff: 'buff_size_chart',
    keychain: 'keychain_size_chart'
  }
  const sizeChart =
    R.path([sizeChartChoices[type]], race) ||
    R.path(['addon_type', 'chart_image'], addons[0]) ||
    R.path(['ship_date'], race)
      ? R.path(['size_chart'], race)
      : null
  const isNotRace = R.pathOr(true, ['ship_date'], race)
  const isMedalAddon = R.path(['addon_type', 'title'], addons[0]) === 'medal'
  const quantityOptions =
    type === 'keychain' || isMedalAddon
      ? [
          { key: 1, text: `ไม่รับ${description}`, value: `no_${type}` },
          { key: 2, text: 1, value: 1 }
        ]
      : [
          { key: 1, text: `ไม่รับ${description}`, value: `no_${type}` },
          { key: 2, text: 1, value: 1 },
          { key: 3, text: 2, value: 2 },
          { key: 4, text: 3, value: 3 },
          { key: 5, text: 4, value: 4 },
          { key: 6, text: 5, value: 5 }
        ]
  const errorLabel = <Label color="red" pointing />
  return (
    addons && (
      <React.Fragment>
        <h3>
          {R.pathOr(null, [overrideText], race)
            ? R.pathOr(null, [overrideText], race)
            : R.pathOr(description, ['addon_type', 'display_title'], addons[0])
            ? `${isNotRace && description} ${
                !R.path(['addon_type'], addons[0])
                  ? R.path(['title'], race)
                  : ''
              }`
            : null}
          {` `}(+{price} บาท)
        </h3>
        {addonImage && (
          <div>
            <img src={getImageUrl(addonImage)} />
          </div>
        )}
        {sizeChart && (
          <div style={{ marginTop: 15 }}>
            <Modal
              closeOnEscape
              closeOnDimmerClick
              trigger={<a>คลิกเพื่อดูขนาด{description}</a>}
              actions={['ปิด']}
            >
              <Modal.Header>รายละเอียดขนาดของ{description}</Modal.Header>
              <Modal.Content>
                <Modal.Description>
                  <img src={getImageUrl(sizeChart)} />
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </div>
        )}
        <br />
        <h3>จำนวน{description}ที่ต้องการสั่ง</h3>
        <Form.Group widths="equal">
          <Form.Select
            name={`numberOf${type}`}
            onChange={handleChange}
            value={numberOf}
            placeholder={`กรุณาเลือกจำนวน${description}ที่ต้องการ`}
            selection
            options={quantityOptions}
          />
        </Form.Group>
        {addons.length > 1 &&
          [...Array(numberOf || 0).keys()].map(x => (
            <Radio.Group
              name={`selected_${type}`}
              {...!(R.isEmpty(selectedAddon) || R.isNil(selectedAddon)) && {
                value: selectedAddon[x]
              }}
              style={{ marginBottom: '1em', marginTop: '1em' }}
              onChange={e => handleRadioChange(e, type)}
            >
              <h5>
                {description}ชิ้นที่ {x + 1}
              </h5>
              {addons.map((each, i) => (
                <React.Fragment>
                  <Radio.Button
                    checked={false}
                    selectAddonIndex={x}
                    value={each.id}
                  >
                    {each.title}
                  </Radio.Button>
                </React.Fragment>
              ))}
            </Radio.Group>
          ))}
        {isMedalAddon && numberOf > 0 && (
          <React.Fragment>
            <h3>สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)</h3>
            <Form.Group>
              <Form.Input
                validations="maxLength:12"
                name="engrave"
                className="mb10"
                style={{ width: '350px', marginBottom: '10px' }}
                value={engrave}
                validationErrors={{
                  maxLength: 'โปรดกรอกไม่เกิน 12 ตัวอักษร'
                }}
                placeholder="สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)"
                onChange={handleEngraveChange}
                errorLabel={errorLabel}
              />
            </Form.Group>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ShirtAddon/index.js